'use client';

import Breadcrumbs from '@/components/Breadcrumbs';
import { useAppContext } from '@/context/app';
// import { useGetCategoryData } from '@/hooks/Category/use-get-category-data';
import { useStickyHeader } from '@/hooks/Category/useCategory';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { getH1Title, getTitle } from '@/lib/get-product-full-detail-seo';
import { appendNofollowMeta, removeNofollowMeta } from '@/lib/nofollow-meta';
import { cn } from '@/lib/utils';
import debounce from 'lodash.debounce';
import { usePathname, useSearchParams } from 'next/dist/client/components/navigation';
import Image from 'next/image';
import { useEffect, useLayoutEffect, useRef } from 'react';
import { CategoryFilterContainer } from './category-filter-container';
import classes from './category.module.css';
// import {
//   CategorySectionTitle
// } from "./category-section-title"
import { pushDataLayer, pushEcommerceEvent } from '@/lib/data-layer';
import { PageViewEvent } from '@/lib/use-page-view-event';
import { GalleryContent } from './gallery-content';
import { LazyLoadSection } from './lazy-load-section';
import { useScrollStore } from './store/use-scroll-store';
import { useGetCategoryDescription } from './use-get-category-desciption';
export const CategoryPage = ({
  uid,
  filters,
  aggregations,
  sortFields,
  nextState,
  categoryProductsData,
  sortState,
  initialFiltersAggregations,
}: any) => {
  const pathname = usePathname();
  const [{ isSticky, isFilterSticky }] = useAppContext();
  const { isMobile } = useIsMobile();
  const { savePosition, getPosition } = useScrollStore();
  // 解构categoryProductsData
  const productsItemsList = categoryProductsData?.products?.items;
  const advertisements = categoryProductsData?.categories?.items?.[0]?.adv || [];
  const categoryUrlKey = categoryProductsData?.categories?.items?.[0]?.url_key || '';
  const totalCount = categoryProductsData?.products?.total_count;
  const totalPage = categoryProductsData?.products?.page_info?.total_pages;
  const currentPageFromData = categoryProductsData?.products?.page_info?.current_page;
  const showLoadMore = currentPageFromData && totalPage ? currentPageFromData < totalPage : false;
  const categoryName = categoryProductsData?.categories?.items?.[0]?.name || null;
  const categoryMetaTitle = categoryProductsData?.categories?.items?.[0]?.meta_title || categoryName || undefined;
  console.log('categoryProductsData', categoryProductsData);
  // 保存滚动位置
  useEffect(() => {
    const handleScroll = () => {
      savePosition(pathname, window.scrollY);
    };

    const throttledScroll = debounce(handleScroll, 100);

    window.addEventListener('scroll', throttledScroll);

    return () => window.removeEventListener('scroll', throttledScroll);
  }, [pathname, savePosition]);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, getPosition(pathname));
    }, 0);
  }, [pathname, getPosition]);
  const colorTitle = getTitle({
    nextState,
    key: 'lw_color',
  });
  const lw_size_shoes_adult_title = getTitle({
    nextState,
    key: 'lw_size_shoes_adult',
  });
  const lw_product_usage_title = getTitle({
    nextState,
    key: 'lw_product_usage',
  });
  const lw_material_title = getTitle({
    nextState,
    key: 'lw_material',
  });

  const isSearchPage = pathname.includes('search');

  const searchParams = useSearchParams();
  const stockStatus = searchParams.get('stock');
  useLayoutEffect(() => {
    if (isSearchPage) {
      return;
    }

    if (nextState?.size > 3 || searchParams.toString()) {
      appendNofollowMeta();
    } else {
      removeNofollowMeta();
    }
  }, [nextState, isSearchPage, searchParams]);

  const colorFilters = filters && filters['lw_color'] ? filters['lw_color']['in'] : [];
  // console.log('productsItemsList', filters, productsItemsList, colorFilters);
  const { category_image, category_image_m } = useGetCategoryDescription({
    categoryId: uid,
    categoryData: categoryProductsData,
  });

  const h1Title = getH1Title({
    colorTitle,
    lw_size_shoes_adult_title,
    lw_product_usage_title,
    lw_material_title,
    categoryName: categoryName ?? '',
  });
  const category_image_url =
    process.env.NEXT_PUBLIC_MAGENTO_BACKEND_URL + (isMobile ? category_image_m : category_image);
  const filterContainerRef = useRef(null);
  const trackedCategoryRef = useRef<string | null>(null);
  useStickyHeader(filterContainerRef);
  const shouldShowCategoryNameTitle = categoryName && (isMobile ? !category_image_m : !category_image);

  useEffect(() => {
    const products = categoryProductsData?.products?.items || [];
    const category = categoryProductsData?.categories?.items?.[0];

    if (!products.length || !category?.uid) {
      return;
    }

    const trackingKey = [
      pathname,
      searchParams.toString(),
      category.uid,
      products.map((item: any) => item?.sku).join(','),
    ].join('|');

    if (trackedCategoryRef.current === trackingKey) {
      return;
    }

    const productItems = products.map((item: any, index: number) => {
      const finalPrice = item?.price_range?.maximum_price?.final_price;

      return {
        item_name: item?.name,
        item_id: item?.sku,
        price: finalPrice?.value,
        currency: finalPrice?.currency,
        quantity: 1,
        index,
      };
    });

    pushEcommerceEvent({
      event: 'view_item_list',
      ecommerce: {
        item_list_id: category.name,
        item_list_name: category.name,
        items: productItems,
      },
    });

    window.pintrk &&
      window.pintrk('track', 'viewcategory', {
        line_items: products.map((item: any) => ({
          product_name: item?.name,
          product_id: item?.uid,
          product_category: category.meta_title || category.name,
          product_price: item?.price_range?.maximum_price?.final_price?.value,
          product_brand: 'hisea',
        })),
      });

    trackedCategoryRef.current = trackingKey;
  }, [categoryProductsData, pathname, searchParams]);

  return (
    <>
      <PageViewEvent pageTitle={categoryMetaTitle} />
      {category_image && (
        <div className='relative'>
          <Image
            src={category_image_url}
            className='h-auto w-full'
            width={isMobile ? 375 : 1920}
            height={isMobile ? 200 : 370}
            alt={categoryName ?? ''}
            loader={({ src }) => src}
            unoptimized
          />
        </div>
      )}
      <div className={cn('container mx-auto px-[16px]')}>
        <Breadcrumbs
          breadcrumbsData={categoryProductsData}
          className={cn('container mx-auto', classes.categoryBreadcrumbs)}
        />
      </div>
      {shouldShowCategoryNameTitle ? (
        <div className='container mx-auto px-[12px] lg_px-0'>
          <h1 className={classes.categoryNameTitle}>{categoryName}</h1>
        </div>
      ) : null}

      <article className={cn('w-full')}>
        <div className={cn('w-full', 'lg_flex', 'flex-col')}>
          <div
            ref={filterContainerRef}
            className={cn(
              'sticky z-10 w-full bg-white',
              isSticky ? (isMobile ? 'top-[60px] shadow-md' : 'top-[74px] shadow-md') : 'top-0 pt-[20px]',
            )}
          >
            <div
              className={cn(
                'container mx-auto  px-[12px] lg_px-0',
                isSticky ? (isMobile ? 'px-[12px] pt-[20px]' : 'pt-[20px]') : '',
              )}
            >
              <CategoryFilterContainer
                categoryId={uid}
                categoryName={categoryName}
                aggregations={aggregations}
                sortFields={sortFields}
                totalCount={totalCount ?? 0}
                currentCurrencyCode={'USD'}
                categoryUrlKey={categoryUrlKey ?? ''}
                filters={filters}
                initialSortState={sortState}
                initialFiltersAggregations={initialFiltersAggregations}
              />
            </div>
          </div>
          <div className={cn('container mx-auto px-[12px] lg_px-0')}>
            <GalleryContent
              items={productsItemsList}
              advertisements={advertisements}
              // categoryLoading={categoryLoading}
              className='border-b border-[#E0E0E0] pb-[20px] pt-0 lg_pb-[40px] lg_pt-[60px] '
              categoryId={uid}
              categoryName={categoryName || ''}
              colorFilters={colorFilters}
            />
            {/* {showLoadMore && (
              <div className={cn('lg_grow', 'pt-[20px] lg_pt-[60px]')}>
                <div className='flex justify-center'>
                  <Button
                    disabled={isFetchingMore}
                    onClick={() => {
                      loadMore();
                    }}
                    className='uppercase'
                  >
                    {isFetchingMore ? 'loading...' : 'load more'}
                  </Button>
                </div>
              </div>
            )} */}
          </div>
        </div>
      </article>
      <LazyLoadSection categoryData={categoryProductsData} />
    </>
  );
};
